import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const ActivityTypeList = () => {
  const fetchUrl = `${API_DOMAIN}${API_ROUTES.customerActivityType}`;

  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Description', value: 'description' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/activity-type/details/${id}`;
  };

  return (
    <div>
      <h1>Activity Types</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default ActivityTypeList;
